import { render, staticRenderFns } from "./ChannelZohoConfigUpdated.vue?vue&type=template&id=73aa72d6"
import script from "./ChannelZohoConfigUpdated.vue?vue&type=script&lang=js"
export * from "./ChannelZohoConfigUpdated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports